import PropTypes from 'prop-types';
import { Wrapper, TeamBox } from './ScoreBoard.styles';

export default function ScoreBoard({ score }) {

  if (!score) return null;
  return (
    <Wrapper>
      <TeamBox>
        <span>{score.teamAName}</span>
        <span className="score">{score.teamAScore}</span>
      </TeamBox>
      <TeamBox>
        <span>{score.teamBName}</span>
        <span className="score">{score.teamBScore}</span>
      </TeamBox>
    </Wrapper>
  );
}

ScoreBoard.propTypes = {
  score: PropTypes.shape({
    teamAName:  PropTypes.string,
    teamAScore: PropTypes.number,
    teamBName:  PropTypes.string,
    teamBScore: PropTypes.number,
  }),
};
